export const customFetch = async (url, param, successCallBack, failureCallBack) => {
  try {
    const response = await fetch(url, param);
    if (response.status === 200) {
      const json = await response.json();
      if (json && json.success) {
        successCallBack(json);
      } else {
        failureCallBack();
        return;
      }
    } else {
      failureCallBack();
    }
  } catch (err) {
    console.log(err);
  }
};
